import { Icon } from './Icon';
import { useSound } from '../lib/sound';

export function SoundToggle(): JSX.Element {
  const { enabled, toggle, play } = useSound();
  return (
    <button
      type="button"
      className="sound-toggle"
      aria-label={enabled ? 'Desativar sons' : 'Ativar sons'}
      aria-pressed={enabled}
      onClick={() => {
        toggle();
        if (!enabled) play('click');
      }}
    >
      <Icon name={enabled ? 'volume' : 'volume-off'} />
      <span>{enabled ? 'Som on' : 'Som off'}</span>
    </button>
  );
}
